import { AD_TYPE_DISPLAY_ORDER, AdType, isSupportedInCreativeGroup } from '@hprofits/shared';
import { ButtonMenuItem } from '@hprofits/ui';
import { ImageSquaredIcon, InterfaceIcon, LayoutIcon, LinkIcon, VideoFilmIcon, WindowIcon } from '@hprofits/ui';
import { hasValue } from '@hprofits/utils/fp/optional';
import { computed, Ref } from 'vue';

import { t } from '@/i18n';
import { AdUnitTypes } from '@/modules/campaigns/composables/state/useAdUnitTypesDataSource';

type CreativeMenuAdType = Exclude<AdType, 'Push' | 'Audio' | 'Vast'>;
type CreativeTypeIconMap = Record<CreativeMenuAdType, ButtonMenuItem['icon']>;

const CREATIVE_TYPE_ORDER = AD_TYPE_DISPLAY_ORDER satisfies ReadonlyArray<CreativeMenuAdType>;

const creativeTypeIcons: CreativeTypeIconMap = {
  Popunder: WindowIcon,
  Banner: ImageSquaredIcon,
  Native: InterfaceIcon,
  Multispot: LayoutIcon,
  Interstitial: WindowIcon,
  InPage: LayoutIcon,
  Link: LinkIcon,
  Video: VideoFilmIcon,
  VideoSlider: VideoFilmIcon,
  OutstreamVideo: VideoFilmIcon,
};

export type UseCreativeTypeItemsProps = Readonly<{
  adUnitTypes: Readonly<Ref<AdUnitTypes | null>>;
  selectType: (type: AdType) => void | Promise<void>;
}>;

export const useCreativeTypeItems = ({
  adUnitTypes,
  selectType,
}: UseCreativeTypeItemsProps): Readonly<Ref<ReadonlyArray<ButtonMenuItem>>> => {
  return computed<ReadonlyArray<ButtonMenuItem>>(() =>
    CREATIVE_TYPE_ORDER.filter(
      (type) =>
        isSupportedInCreativeGroup(type) &&
        (hasValue(adUnitTypes.value) ? adUnitTypes.value.adUnits.map((unit) => unit.name).includes(type) : true),
    ).map((type) => ({
      label: t(`modules.campaigns.summary.creativeTypes.${type}`),
      icon: creativeTypeIcons[type],
      onClick: () => selectType(type),
    })),
  );
};
